export default "__VITE_ASSET__g_KbfowE__"